    /**
     * Responsive
     */
    var ElementResponsive = function(body,mainHeader,navHeader,content,footer){

        var vwp = {
            width : jQuery(window).width(),
            height : jQuery(window).height()
        }

        body.css({
            paddingTop: mainHeader.height()
        })
        if(vwp.width < 1024 && vwp.width >= 768){
            navHeader.css({
                top: mainHeader.height()
            })
        } else if(vwp.width < 768) {
            navHeader.css({
                top: mainHeader.height()
            })
            CenterModeCarousel('.employer-branding-wrapper','.item-azienda');
        } else {
            /**
             * Resize del container:
             * fa in modo che il footer 
             * non sia troppo in alto, 
             * se il container ha poco contenuto
             */
            PageHeight = mainHeader.outerHeight()+content.outerHeight()+footer.outerHeight();
            if(PageHeight < vwp.height){
                content.css({
                    minHeight : vwp.height - (mainHeader.outerHeight()+footer.outerHeight())
                })
            }

            /**
             * Distruggo i caroselli
             */
            CenterModeCarousel('.employer-branding-wrapper','.item-azienda',true);
        }
    }

    var CenterModeCarousel = function (containerClass,itemClass,destroy) {
        var Container = jQuery(containerClass),
            isInitalize = jQuery(containerClass+'.slick-initialized').length;
            DidDestroy = destroy ? true : false;
            
            if( DidDestroy && isInitalize ) {
                jQuery(containerClass).slick("unslick");
                return;
            }
            if( !DidDestroy && Container.length && !isInitalize ) {
                var that = Container,
                    Item = that.find(itemClass),
                    ItemWidth = Item.width() / 2;
                    that.slick({
                        dots: true,
                        arrows: false,
                        infinite: true,
                        edgeFriction: 1,
                        useCSS: true,
                        cssEase: 'ease-in-out',
                        useTransform: true,
                        cssEase: 'ease-in-out',
                        speed: 250,
                        slidesToShow: 1,
                        centerMode: true,
                        width: ItemWidth
                    })
            }
    }

    var FiltersMenu = function(element){

        var SelectedClass = 'MenuSelected', 
            OpenClass = 'opened',
            BtnSubmit = jQuery('#get-filters');

        function MenuActive(Elements,Menu){
            var ifChecks = [];
            Elements.each(function(){
                ifChecks.push(this.checked);
            });
            if(ifChecks.indexOf(true) != -1) {
                Menu.addClass(SelectedClass)
            } else {
                Menu.removeClass(SelectedClass)
            }
        }

        element.each(function(){
            var Container = jQuery(this),
                currentBtn = Container.find('.selected'),
                checkboxs = Container.find('input[type="checkbox"]');
                
                currentBtn.on('click',function(){
                    jQuery('.filterOption').not(Container).removeClass(OpenClass);
                    var thisContainer = jQuery(this).parent();
                        if(thisContainer.hasClass(OpenClass)) {
                            thisContainer.removeClass(OpenClass)
                        } else { 
                            thisContainer.addClass(OpenClass)
                        }
                    
                });
                checkboxs.each(function(){
                    var that = jQuery(this),
                        relatedElement = jQuery('#'+that.attr('data-rel'));
                        that.on('change',function(){
                            relatedElement.attr("checked",this.checked);
                            BtnSubmit.trigger('click');
                            MenuActive(checkboxs,Container);
                        });
                });

                MenuActive(checkboxs,Container);
        });
    }

    /**
     * Home effetto typing
     */
    var TxtType = function(el, toRotate, period) {
        this.toRotate = toRotate;
        this.el = el;
        this.loopNum = 0;
        this.period = parseInt(period, 10) || 2000;
        this.txt = '';
        this.tick();
        this.isDeleting = false;
    };

    TxtType.prototype.tick = function() {
        var i = this.loopNum % this.toRotate.length;
        var fullTxt = this.toRotate[i];

        if (this.isDeleting) {
            this.txt = fullTxt.substring(0, this.txt.length - 1);
        } else {
            this.txt = fullTxt.substring(0, this.txt.length + 1);
        }

        this.el.innerHTML = '<span class="wrap">'+this.txt+'</span>';

        var that = this;
        var delta = 150 - Math.random() * 100;

        if (this.isDeleting) { delta /= 2; }

        if (!this.isDeleting && this.txt === fullTxt) {
        delta = this.period;
        this.isDeleting = true;
        } else if (this.isDeleting && this.txt === '') {
        this.isDeleting = false;
        this.loopNum++;
        delta = 2000;
        }

        setTimeout(function() {
            that.tick();
        }, delta);
    };

    function Typing(element){
        var toRotate = element.getAttribute('data-type');
        var period = element.getAttribute('data-period');
            if (toRotate) {
              new TxtType(element, JSON.parse(toRotate), period);
            }
    }

    var LiveList = (function () {
        function LiveList(settings) {
            // this.settings =settings;
            this.settings = settings;
        }
        LiveList.prototype.refresh = function () {
            var _this = this;
            $.get(this.getUrl("list"), $(this.settings.filterWrapper).serialize(), function (data) {
                $(_this.settings.listWrapper).html(data);
                _this.settings.onListRefresh();
            });
        };
        LiveList.prototype.form = function () {
            var _this = this;
            $.get(this.url("list"), {}, function (data) {
                $(_this.settings.listWrapper).html(data);
            });
        };
        LiveList.prototype.confirmDelete = function () {
        };
        LiveList.prototype.getUrl = function (endpoint) {
            return this.settings.route + "/" + endpoint;
        };
        return LiveList;
    }());


    var LazyLoad = function (lazyImages,active) {
        var lazies = document.querySelectorAll(lazyImages);
        if(lazies.length){
        var lazyImages = [].slice.call(lazies);
            if (active === false) {
                console.log('try')
                active = true;

                setTimeout(function () {
                    lazyImages.forEach(function (lazyImage) {
                        
                        if (
                            (lazyImage.getBoundingClientRect().top <= window.innerHeight && 
                            lazyImage.getBoundingClientRect().bottom >= 0) && 
                            getComputedStyle(lazyImage).display !== "none") {
                            
                            lazyImage.src = lazyImage.dataset.src;
                            lazyImage.classList.remove("lazy");

                            lazyImages = lazyImages.filter(function (image) {
                                return image !== lazyImage;
                            });

                            if (lazyImages.length === 0) {
                                document.removeEventListener("scroll", function() { LazyLoad(lazyImages,active) });
                                window.removeEventListener("resize", function() { LazyLoad(lazyImages,active) });
                                window.removeEventListener("orientationchange", function() { LazyLoad(lazyImages,active) } );
                            }
                        }
                    });

                    active = false;
                }, 200);
            }
        }
    };

    var LadyBackgrounds = function(ElementClass){
        var lazyBackgrounds = [].slice.call(document.querySelectorAll(ElementClass));

        if ("IntersectionObserver" in window) {
          var lazyBackgroundObserver = new IntersectionObserver(function(entries, observer) {
            entries.forEach(function(entry) {
              if (entry.isIntersecting) {
                entry.target.classList.add("visible");
                lazyBackgroundObserver.unobserve(entry.target);
              }
            });
          });
      
          lazyBackgrounds.forEach(function(lazyBackground) {
            lazyBackgroundObserver.observe(lazyBackground);
          });
        }      
    }

    function loadScript(url, callback){

        var script = document.createElement("script")
        script.type = "text/javascript";
    
        if (script.readyState){
            script.onreadystatechange = function(){
                if (script.readyState == "loaded" ||
                        script.readyState == "complete"){
                    script.onreadystatechange = null;
                    if(callback) callback();
                }
            };
        } else {
            script.onload = function(){
                if(callback) callback();
            };
        }
    
        script.src = url;
        document.getElementsByTagName("head")[0].appendChild(script);
    }
    
    function isMobile(){
        var ua = navigator.userAgent.toLowerCase(),
        platform = navigator.platform.toLowerCase();
        platformName = ua.match(/ip(?:ad|od|hone)/) ? 'ios' : (ua.match(/(?:webos|android)/) || platform.match(/mac|win|linux/) || ['other'])[0],
        isMobile = /ios|android|webos/.test(platformName);
        return isMobile;
    }

    function setCookie(cname, cvalue, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + (exdays*24*60*60*1000));
        var expires = "expires="+ d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }

    function getCookie(cname) {
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for(var i = 0; i <ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    jQuery(document).ready(function(){

        var body = jQuery('body'),
            mainHeader = jQuery('#mainHeader'),
            navHeader = jQuery('#navHeader'),
            content = jQuery('#content'),
            footer = jQuery('#mainFooter');


            ElementResponsive(body,mainHeader,navHeader,content,footer);
            jQuery(window).on('resize',function(){
                ElementResponsive(body,mainHeader,navHeader,content,footer);
            });
            jQuery(document).scroll(function(){
                var scrollNow = jQuery(window).scrollTop();
                if(scrollNow > mainHeader.height()) {
                    mainHeader.addClass('fixed');
                } else {
                    mainHeader.removeClass('fixed');
                }
            });

            /**
             * Hamburger Menu
             */
            var HamburgerBtn = jQuery('#hamburgerMenu'),
                IconActiveClass = 'is-active',
                GeneralActiveClass = 'menu-is-active';
                HamburgerBtn.on('click',function(){
                var that = jQuery(this);
                    that.hasClass(IconActiveClass) ? (
                            that.removeClass(IconActiveClass),
                            mainHeader.removeClass(GeneralActiveClass),
                            body.removeClass(GeneralActiveClass)
                        ) : (
                            that.addClass(IconActiveClass),
                            mainHeader.addClass(GeneralActiveClass),
                            body.addClass(GeneralActiveClass)
                        );
                });


            /**
             * Bottone "salva nei preferiti"
             */
            var BASE_URL = window.location.origin+'/services/',
                BtnFavourties = jQuery('.ril-btn--favourites');

            if(BtnFavourties.length){
                BtnFavourties.each(function(){
                    var that = jQuery(this),
                        progetto_id = parseInt(that.data('progetto_id')),
                        savedString = that.data('saved');
            
                        jQuery.get(BASE_URL+'favourites/get/',{ 
                                id_progetto : progetto_id 
                            },function(response){
                                if(response.status == 'OK'){
                                    that.addClass('saved');
                                    that.text(savedString)
                                }
                        });
            
                        that.animate({opacity: 1})
                });
            
                BtnFavourties.on('click',function(){
                    var that = jQuery(this),
                        progetto_id = parseInt(that.data('progetto_id')),
                        noSavedString = that.data('nosaved'),
                        savedString = that.data('saved');
                        if(that.hasClass('saved')){
                            jQuery.post(BASE_URL+'favourites/delete/',{ 
                                    id_progetto : progetto_id 
                                },function(response){
                                    if(response.status == 'OK'){
                                        that.removeClass('saved');
                                        
                                        that.text(noSavedString);
                                    }
                            });
                        } else {
                            jQuery.post(BASE_URL+'favourites/store',{ 
                                    id_progetto : progetto_id 
                                },function(response){
                                    if(response.status == 'OK'){
                                        that.addClass('saved');
                                        that.text(savedString);
                                    }
                            });
                        }
                });
            }

            
            var Element = document.getElementById('typewrite')
            if(Element && jQuery(window).width() > 768){
                Typing(Element);
            }

            var LoghiCarousel = jQuery('#loghi-partner-slide');
                if(LoghiCarousel.length) {
                    LoghiCarousel.slick({
                        speed: 5000,
                        autoplay: true,
                        autoplaySpeed: 0,
                        centerMode: true,
                        cssEase: 'linear',
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        variableWidth: true,
                        infinite: true,
                        initialSlide: 1,
                        arrows: false,
                        buttons: false
                    });
                }

            var filterOption = jQuery('.filterOption');
                if(filterOption.length){
                    FiltersMenu(filterOption);
                }

            var SocialItems = jQuery('.box-socialshare');
                if(SocialItems.length){
                    SocialItems.find('li a').each(function(){
                        var that = jQuery(this),
                            href = that.data('href');
                            that.click(function(e){
                                e.preventDefault();
                                window.open(href,'','menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=600,width=600')
                            })
                    });
                }

            var HomeRicerca = jQuery('#mainSearch.node-home');
                if(HomeRicerca.length){
                    var FormElement = jQuery('form#ricerca');
                    jQuery('#select_type').on('change',function(){
                        var action = FormElement.data(this.value);
                        FormElement.attr('action',action);
                    });
                }
            
            var lazyImages = "img.lazy",
                lazies = document.querySelectorAll(lazyImages),
                active = false;
                if(lazies.length){
                    LazyLoad(lazyImages,active);
                    document.addEventListener("scroll", function() { LazyLoad(lazyImages,active) });
                    window.addEventListener("resize", function() { LazyLoad(lazyImages,active) });
                    window.addEventListener("orientationchange", function() { LazyLoad(lazyImages,active) });
                }

            var LazyBg = document.querySelectorAll(lazyImages);
                if(LazyBg.length){
                    LadyBackgrounds(".lazy-background");
                }

    });